export const HEADLINE_CONFIG = {
    healthy: {
        headline: 'Scale your prospecting',
        subtext: 'Move to a higher plan to unlock more credits and advanced capabilities.',
    },
    almostOut: {
        headline: 'Ready for more?',
        subtext: `You’re almost at your limit. Keep your momentum going.`,
    },
    outOfCredits: {
        headline: "Don't lose momentum",
        subtext: `You’ve hit your limit. Upgrade to keep building your pipeline today.`,
    },
};
export const BILLING_CYCLES = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
};
export const DEFAULT_SEAT_AMOUNT = 2;
